<script lang="ts">
  import Button from './Button.svelte';
  import Icon from './Icon.svelte';

  export let pageSize: number;
  export let totalElements: number;
  export let currentPageIndex: number = 0;

  let lastPageIndex = 0;

  let isOnFirstPage = true;
  let isOnLastPage = false;

  const onChange = () => {
    lastPageIndex = Math.max(Math.ceil(totalElements / pageSize) - 1, 0);
    isOnFirstPage = currentPageIndex === 0;
    isOnLastPage = currentPageIndex === lastPageIndex;
  };

  $: currentPageIndex, totalElements, onChange();
  $: paginationStart = pageSize * currentPageIndex + 1;
  $: paginationEnd = Math.min((currentPageIndex + 1) * pageSize, totalElements);
</script>

<div class="wrapper">
  <p>
    {totalElements > 0 ? paginationStart : 0}-{paginationEnd} von {totalElements}
  </p>

  <div class="navigation">
    <Button size="small" disabled={isOnFirstPage} on:click={() => (currentPageIndex = 0)}
      ><Icon variant="firstPage" /></Button
    >
    <Button size="small" disabled={isOnFirstPage} on:click={() => (currentPageIndex -= 1)}
      ><Icon variant="prevPage" /></Button
    >
    <Button disabled={isOnLastPage} size="small" on:click={() => (currentPageIndex += 1)}
      ><Icon variant="nextPage" /></Button
    >
    <Button disabled={isOnLastPage} size="small" on:click={() => (currentPageIndex = lastPageIndex)}
      ><Icon variant="lastPage" /></Button
    >
  </div>
</div>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';

  .wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: spacing.$s;
    border-top: 1px solid colors.$black10;
    padding: spacing.$s;
  }

  .navigation {
    display: flex;
    gap: spacing.$xxs;
  }
</style>
